// 气象站详情
export default {
    equipmentName: 'Название оборудования',
    altitude: 'высота',
    firmwareVersion: 'Версия прошивки',
    position: 'должность',
    windSpeed: 'Скорость ветра',
    windDirection: 'направление ветра',
    temperature: 'температура',
    humidity: 'влажность',
    airPressure: 'Давление воздуха',
    cumulativeTime: 'совокупное время',
    export: 'Экспорт',
    lastWeek: 'Прошлая неделя',
    lastMonth: 'Прошлый месяц',
    lastThreeMonths: 'Последние три месяца',
    time: 'время',
    northWind: 'Северный ветер',
    northeastWind: 'Северо-восточный ветер',
    eastWind: 'Восток ветер',
    southeastWind: 'Юго-восточный ветер',
    southWind: 'южный ветер',
    southwestWind: 'Юго-западный ветер',
    weatWind: 'Западный ветер',
    northwestWind: 'Северо-западный ветер',
}